/* istanbul ignore file */
export { default } from './RRPShoppingCart';
